import { Colors } from '../../../../models/disciplines';
import { getDisciplineName } from '../../../../utils/discipline';
import { Tag, TagProps } from '../../../atoms/Tag';
import PageHeader from '../../../molecules/Header';
import { Typography } from '../../../molecules/Typography';
import { ContentActions } from '../../ContentActions';
import { Breadcrumbs, BreadcrumbsItem } from '../../Breadcrumbs';

interface Subject {
  title: string;
  _id: string;
}

interface LessonHeaderProps {
  title: string;
  discipline: string;
  breadcrumb: BreadcrumbsItem[];
  tags: TagProps[];
  subjects?: string | Subject[];
  timeLesson: string;
  teacher: string;
  recordedAt?: string;
  id: string;
  contentSlug?: string;
  contentType?: 'Lesson' | 'Material' | 'Live';
  isLiveStream: boolean;
  review?: 'like' | 'dislike' | undefined;
  isFavorite?: boolean;
  showFavorite: boolean;
  scoreProps: Record<string, any>;
}

export default function LessonHeader({
  title,
  discipline,
  breadcrumb,
  tags,
  subjects,
  timeLesson,
  teacher,
  recordedAt,
  id,
  contentSlug,
  contentType,
  isLiveStream,
  review,
  isFavorite,
  showFavorite,
  scoreProps,
}: LessonHeaderProps) {
  return (
    <>
      <Breadcrumbs items={breadcrumb} className='pb-12' />
      <div className='pb-8'>
        <PageHeader title={title} module={getDisciplineName(discipline)} {...scoreProps}>
          <div className='flex flex-col gap-md'>
            <div className='flex flex-wrap gap-sm'>
              {tags.map((tag, index) => (
                <Tag key={index} {...tag} />
              ))}
              {typeof subjects === 'string' ? (
                <Tag
                  variant={discipline as Colors}
                  className='flex flex-row items-center gap-sm px-2'
                >
                  <Typography size='small' className='text-[#fff]'>
                    {subjects}
                  </Typography>
                </Tag>
              ) : Array.isArray(subjects) ? (
                subjects.map((subject: { title: string }, index: number) => (
                  <Tag
                    key={index}
                    variant={discipline as Colors}
                    className='flex flex-row items-center gap-sm px-2'
                  >
                    <Typography size='small' className='text-[#fff]'>
                      {subject.title}
                    </Typography>
                  </Tag>
                ))
              ) : null}
            </div>
            <div className='flex items-center justify-between gap-3 pt-1'>
              <div className='mr-auto flex justify-between gap-3'>
                {timeLesson && (
                  <Typography size='small'>{timeLesson}</Typography>
                )}
                {teacher && (
                  <Typography size='small'>Prof. {teacher}</Typography>
                )}
                {recordedAt && (
                  <Typography size='small'>{recordedAt}</Typography>
                )}
              </div>
              <ContentActions.Root
                contentId={id}
                contentSlug={contentSlug}
                contentType={contentType ? contentType : 'Lesson'}
                className='ml-auto'
              >
                {!isLiveStream && (
                  <ContentActions.ReviewButtons defaultReview={review} />
                )}
                {showFavorite && (
                  <ContentActions.FavoriteButton
                    defaultFavorite={isFavorite}
                    category={isLiveStream ? 'live' : 'lesson'}
                  />
                )}
                <ContentActions.Report />
              </ContentActions.Root>
            </div>
          </div>
        </PageHeader>
      </div>
    </>
  );
}
